module.exports = __webpack_public_path__ + "static/media/main idea.913373bc.mp3";